import { render, staticRenderFns } from "./WechatSet.vue?vue&type=template&id=b3084618&scoped=true"
import script from "./WechatSet.vue?vue&type=script&lang=js"
export * from "./WechatSet.vue?vue&type=script&lang=js"
import style0 from "./WechatSet.vue?vue&type=style&index=0&id=b3084618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3084618",
  null
  
)

export default component.exports